import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { getUserDealList } from '@dealstack/frontend/shared/dataExchange/services/project.service';
import { SummaryDealTct } from '@dealstack/shared/lib/generated';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';

type Options = Omit<
	UseQueryOptions<ApiV1.Response<SummaryDealTct[]>, unknown, SummaryDealTct[], [string]>,
	'queryKey' | 'queryFn' | 'select'
>;

export const useDeals = (
	options: Options
): UseQueryResult<SummaryDealTct[] | undefined, unknown> => {
	return useQuery({
		queryKey: [formatUnicorn(API_PATHS.DEAL_GET)],
		queryFn: ({ signal }) => getUserDealList(signal),
		select: (data) => data.payload,
		...options,
	});
};
